import { render, staticRenderFns } from "./createFlow.vue?vue&type=template&id=16d6680e&"
import script from "./createFlow.vue?vue&type=script&lang=js&"
export * from "./createFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports